import arrowImg from "../../../../../picture/PlayLanguage.png";
import { useEffect, useRef, useState } from "react";

// values are strings
const CustomAutocomplete = ({
  allValues = [],
  selectedValue,
  onSelectChange,
  label,
  style = {},
  isUp = true,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const [stylesUp, setStylesUp] = useState({});

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    const newValue = value === selectedValue ? "" : value;
    if (onSelectChange) onSelectChange(newValue);
    setIsOpen(false);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";

    if (isUp) {
      const stUp = {
        left: rect.left,
        width: rect.width,
        bottom: window.innerHeight - rect.top
      };
      setStylesUp(stUp);
    }

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef} style={{ ...style, position: "relative" }}>
      <div
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          marginBottom: "5px"
        }}
      >
        {label}
      </div>
      <div onClick={handleOpen} style={{ position: "relative" }}>
        <input
          type="text"
          value={selectedValue}
          onChange={(e) => onSelectChange(e.target.value)}
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px",
            height: "40px",
            padding: "5px"
          }}
          disabled={disabled}
        />

        {!disabled && (
          <div
            style={{
              width: "30px",
              position: "absolute",
              right: "0px",
              top: "12px",
              backgroundColor: "transparent"
            }}
          >
            <img
              src={arrowImg}
              alt=""
              className="profile-select-item-img"
              style={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
            />
          </div>
        )}
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "absolute",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)",
          maxHeight: "300px",
          overflowY: "auto",
          width: "100%",
          overflowY: "auto",
          ...stylesUp,
          ...style
        }}
      >
        {!disabled &&
          allValues.map((value, index) => (
            <div
              key={value}
              onClick={() => handleSelect(value)}
              style={{
                wordBreak: "break-word",
                padding: "5px",
                borderBottom: "1px solid black",
                cursor: "pointer",
                backgroundColor: value == selectedValue ? "lightgrey" : "white",
                display: "flex",
                alignItems: "center",
                fontSize: "16px"
              }}
            >
              {value}
            </div>
          ))}
      </div>
    </div>
  );
};

export default CustomAutocomplete;
